import { FormError, Label, LabelProps } from '@kcftech/design-system';
import { Modify } from 'utils/types';

export type ValidatableLabelProps = Modify<
    LabelProps,
    {
        error: { message?: string } | string | undefined;
        ariaLabel?: string;
    }
>;

export function ValidatableLabel({
    error,
    children,
    ariaLabel,
    ...rest
}: ValidatableLabelProps) {
    return (
        <Label ariaLabel={ariaLabel} {...rest}>
            {children}
            {error && (
                <FormError message={typeof error === 'object' ? error.message : error} />
            )}
        </Label>
    );
}
